import request from "../utils/request";

/**
 * 获取考试题目列表
 * @param {Object} params - 请求参数
 * @param {string} [params.taskId] - 学习任务ID
 * @returns {Promise<Object>} 包含考试题目数据的 Promise
 */
export function examQuestion(params) {
  return request({
    auth: false,
    url: "/pc/video/exam/question",
    method: "get",
    params,
  });
}

/**
 * 提交考试题目答案
 * @param {Object} data - 提交数据
 * @param {string} data.id - 试卷ID
 * @param {Array<{id: string, answer: string}>} data.questions - 答题列表
 * @returns {Promise<Object>} 提交结果数据
 */
export function examCommit(data) {
  return request({
    auth: false,
    url: "/pc/video/exam/commit",
    method: "post",
    data,
  });
}

/**
 * 获取答题情况详情
 * @param {Object} params - 请求参数
 * @param {string} params.id - 答题记录ID
 * @returns {Promise<Object>} 答题情况数据
 */
export function examSituation(params) {
  return request({
    auth: false,
    url: "/pc/video/results",
    method: "get",
    params,
  });
}
